import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface FloatingPillProps {
  /** Left-hand description, e.g. "Fr, 21.08. → So, 23.08.". */
  label: string;
  actionLabel: string;
  onAction: () => void;
  /** Renders a cancel control. Escape alone is no help on a touch device. */
  onDismiss?: () => void;
  dismissLabel?: string;
  className?: string;
}

/**
 * The dark confirmation bar that appears once a range has been picked. It is a
 * deliberate extra step: the selection stays visible and correctable instead of
 * the modal opening the instant the second day is tapped.
 */
export function FloatingPill({
  label,
  actionLabel,
  onAction,
  onDismiss,
  dismissLabel,
  className,
}: FloatingPillProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-3 rounded-card bg-accent px-3 py-2.5 shadow-pill',
        className,
      )}
    >
      <span className="min-w-0 text-control font-medium text-accent-fg">{label}</span>
      <div className="flex shrink-0 items-center gap-1.5">
        <button
          type="button"
          onClick={onAction}
          className="hit-44 rounded-cell bg-card px-3 py-1.5 text-label font-semibold text-fg"
        >
          {actionLabel}
        </button>
        {onDismiss ? (
          <button
            type="button"
            onClick={onDismiss}
            aria-label={dismissLabel}
            className="hit-44 grid size-7 place-items-center rounded-cell text-accent-fg"
          >
            <X className="size-3.5" />
          </button>
        ) : null}
      </div>
    </div>
  );
}
